import { Component, Input } from '@angular/core';
import { ModalRef } from '@shared/ui';
import { ButtonColor } from '@shared/ui/button/button.component';

@Component({
  template: `
    <div class="MainBody">
      {{ warning }}
    </div>
    <div class="ActionContainer">
      <fl-button class="ActionButton"
        [color]="ButtonColor.SECONDARY"
        (click)="modalRef.close(true)"
      >
        {{ confirm }}
      </fl-button>
      <fl-button class="ActionButton"
        [color]="ButtonColor.DEFAULT"
        (click)="modalRef.close(false)"
      >
        {{ cancel }}
      </fl-button>
    </div>
  `,
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  ButtonColor = ButtonColor;

  @Input() cancel = 'Cancel';
  @Input() confirm = 'Confirm';
  @Input() warning: string;

  modalRef: ModalRef<ConfirmModalComponent>;

  constructor(modalRef: ModalRef<ConfirmModalComponent>) {
    this.modalRef = modalRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/messaging/messaging-chat/confirm-modal/confirm-modal.component.ts